/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Check if two locations are equal using deep equality checks
 */

import deepequal from 'fast-deep-equal'
import { RouteComponentProps } from 'react-router-dom'

import { MaybeRouteProps } from '../types'

type Location = MaybeRouteProps['location'] | RouteComponentProps['location']

export const locationsEqual = (location: Location, prevLocation: Location) => {
  if (location === prevLocation || (!location && !prevLocation)) {
    return true
  }
  if (!location || !prevLocation) {
    return false
  }
  const { hash, pathname, search, state } = location
  return (
    hash === prevLocation.hash &&
    pathname === prevLocation.pathname &&
    search === prevLocation.search &&
    deepequal(state, prevLocation.state)
  )
}
